module.exports = __webpack_public_path__ + "assets/img/Methodist Girls’ School.b01d8f95.jpg";